/* SPECIFIC JS FOR THE VIEW IF NEEDED */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = projet_fc0f3_services;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _scrollmagic = require('scrollmagic');

var _scrollmagic2 = _interopRequireDefault(_scrollmagic);

var _swiper = require('swiper');

var _swiper2 = _interopRequireDefault(_swiper);

require("scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap");

var _xhr = require('xhr');

var _xhr2 = _interopRequireDefault(_xhr);

function projet_fc0f3_services() {
  var self = this;

  var _rub = document.querySelector('.b4s3_home');

  function addListeners() {
    _pubsub2['default'].on('resize', resize);
  }

  function resize(winW, winH) {
    console.log('HOME resize > script/wiews/b4s3_home.js');
  }

  var maxTranslate;

  setTimeout(function () {
    if (document.querySelector('.visual-container img')) {
      maxTranslate = document.querySelector('.visual-container img').offsetHeight - window.innerHeight;
    } else {
      maxTranslate = 0;
    }
  }, 1000);

  function listHover() {
    var listItems = document.querySelectorAll('.services-list li');

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = listItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        item.addEventListener('mouseover', function () {
          var translate = parseInt(this.getAttribute('data-floor')) * maxTranslate / 49;
          console.log(translate, maxTranslate, parseInt(this.getAttribute('data-floor')));
          TweenMax.to('.visual-container img', 1, {
            y: translate
          });

          document.querySelector('.services-list .current-floor-value').innerHTML = this.querySelector('.second-part').innerHTML;

          var titles = document.querySelectorAll('.floor-title');

          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = titles[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var title = _step3.value;

              if (title.getAttribute('data-floor') === this.getAttribute('data-floor')) {
                title.classList.add('active');
              } else {
                title.classList.remove('active');
              }
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3['return']) {
                _iterator3['return']();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        });
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator['return']) {
          _iterator['return']();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    document.querySelector('li.current').addEventListener('click', function () {
      document.querySelector('.services-list-mobile').classList.add('active');
    });

    var listItemMobile = document.querySelectorAll('.services-list-mobile li:not(.current)');

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = listItemMobile[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var item = _step2.value;

        item.addEventListener('click', function (e) {
          document.querySelector('.title-container .current-floor-value').innerHTML = this.querySelector('.second-part').innerHTML;
          document.querySelector('.services-list-mobile').classList.remove('active');
          document.querySelector('.services-list-mobile .current').innerHTML = this.innerHTML;
          var translate = parseInt(this.getAttribute('data-floor')) * maxTranslate / 49;
          TweenMax.to('.visual-container img', 1, {
            y: translate
          });

          document.querySelector('.current-floor-value').innerHTML = this.querySelector('.second-part').innerHTML;

          var titles = document.querySelectorAll('.floor-title');

          var _iteratorNormalCompletion4 = true;
          var _didIteratorError4 = false;
          var _iteratorError4 = undefined;

          try {
            for (var _iterator4 = titles[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
              var title = _step4.value;

              if (title.getAttribute('data-floor') === this.getAttribute('data-floor')) {
                title.classList.add('active');
              } else {
                title.classList.remove('active');
              }
            }
          } catch (err) {
            _didIteratorError4 = true;
            _iteratorError4 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion4 && _iterator4['return']) {
                _iterator4['return']();
              }
            } finally {
              if (_didIteratorError4) {
                throw _iteratorError4;
              }
            }
          }
        });
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2['return']) {
          _iterator2['return']();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  function chevronClick() {
    var maxTranslate = document.querySelector('.visual-container img').offsetHeight - window.innerHeight;

    document.querySelector('.services-list .chevron-up').addEventListener('click', function () {
      var currentItem = document.querySelector('.services-list li[data-floor="' + document.querySelector('.services-list .current-floor-value').innerHTML + '"]');

      if (currentItem.previousElementSibling.querySelector('.second-part')) {
        console.log(currentItem, currentItem.previousElementSibling);
        var translate = parseInt(currentItem.previousElementSibling.getAttribute('data-floor')) * maxTranslate / 49;
        TweenMax.to('.visual-container img', 1, {
          y: translate
        });

        document.querySelector('.services-list .current-floor-value').innerHTML = currentItem.previousElementSibling.querySelector('.second-part').innerHTML;

        var titles = document.querySelectorAll('.floor-title');

        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = titles[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var title = _step5.value;

            if (title.getAttribute('data-floor') === currentItem.previousElementSibling.getAttribute('data-floor')) {
              title.classList.add('active');
            } else {
              title.classList.remove('active');
            }
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5['return']) {
              _iterator5['return']();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }
      }
    });

    document.querySelector('.services-list .chevron-down').addEventListener('click', function () {
      var currentItem = document.querySelector('.services-list li[data-floor="' + document.querySelector('.services-list .current-floor-value').innerHTML + '"]');

      if (currentItem.nextElementSibling) {
        var translate = parseInt(currentItem.nextElementSibling.getAttribute('data-floor')) * maxTranslate / 49;
        TweenMax.to('.visual-container img', 1, {
          y: translate
        });

        document.querySelector('.services-list .current-floor-value').innerHTML = currentItem.nextElementSibling.querySelector('.second-part').innerHTML;

        var titles = document.querySelectorAll('.floor-title');

        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = titles[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var title = _step6.value;

            if (title.getAttribute('data-floor') === currentItem.nextElementSibling.getAttribute('data-floor')) {
              title.classList.add('active');
            } else {
              title.classList.remove('active');
            }
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6['return']) {
              _iterator6['return']();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
    });

    document.querySelector('.title-container .chevron-up').addEventListener('click', function () {
      var currentItem = document.querySelector('.services-list li[data-floor="' + document.querySelector('.title-container .current-floor-value').innerHTML + '"]');

      if (currentItem.previousElementSibling.querySelector('.second-part')) {
        var translate = parseInt(currentItem.previousElementSibling.getAttribute('data-floor')) * maxTranslate / 49;
        TweenMax.to('.visual-container img', 1, {
          y: translate
        });

        document.querySelector('.title-container .current-floor-value').innerHTML = currentItem.previousElementSibling.querySelector('.second-part').innerHTML;

        var titles = document.querySelectorAll('.floor-title');

        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = titles[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var title = _step7.value;

            if (title.getAttribute('data-floor') === currentItem.previousElementSibling.getAttribute('data-floor')) {
              title.classList.add('active');
            } else {
              title.classList.remove('active');
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7['return']) {
              _iterator7['return']();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
    });

    document.querySelector('.title-container .chevron-down').addEventListener('click', function () {
      var currentItem = document.querySelector('.services-list li[data-floor="' + document.querySelector('.title-container .current-floor-value').innerHTML + '"]');

      if (currentItem.nextElementSibling) {
        var translate = parseInt(currentItem.nextElementSibling.getAttribute('data-floor')) * maxTranslate / 49;
        TweenMax.to('.visual-container img', 1, {
          y: translate
        });

        document.querySelector('.title-container .current-floor-value').innerHTML = currentItem.nextElementSibling.querySelector('.second-part').innerHTML;

        var titles = document.querySelectorAll('.floor-title');

        var _iteratorNormalCompletion8 = true;
        var _didIteratorError8 = false;
        var _iteratorError8 = undefined;

        try {
          for (var _iterator8 = titles[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
            var title = _step8.value;

            if (title.getAttribute('data-floor') === currentItem.nextElementSibling.getAttribute('data-floor')) {
              title.classList.add('active');
            } else {
              title.classList.remove('active');
            }
          }
        } catch (err) {
          _didIteratorError8 = true;
          _iteratorError8 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion8 && _iterator8['return']) {
              _iterator8['return']();
            }
          } finally {
            if (_didIteratorError8) {
              throw _iteratorError8;
            }
          }
        }
      }
    });
  }

  function listClick() {
    var listItems = document.querySelectorAll('.services-list li');

    var clickedItems = document.querySelectorAll('.clicked-item');

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = clickedItems[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var item = _step9.value;

        item.classList.remove('active');
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9['return']) {
          _iterator9['return']();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = listItems[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var item = _step10.value;

        item.addEventListener('click', function (e) {
          document.querySelector('.clicked-container').classList.add('active');
          document.querySelector('.clicked-item[data-floor="' + this.getAttribute('data-floor') + '"]').classList.add('active');
        });
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10['return']) {
          _iterator10['return']();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }

    var titles = document.querySelectorAll('.floor-title');

    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      for (var _iterator11 = titles[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        var t = _step11.value;

        t.addEventListener('click', function () {
          document.querySelector('.clicked-container').classList.add('active');
          document.querySelector('.clicked-item[data-floor="' + this.getAttribute('data-floor') + '"]').classList.add('active');
        });
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11['return']) {
          _iterator11['return']();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }

    var back = document.querySelectorAll('.back');

    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      for (var _iterator12 = back[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        var b = _step12.value;

        b.addEventListener('click', function () {
          var _iteratorNormalCompletion13 = true;
          var _didIteratorError13 = false;
          var _iteratorError13 = undefined;

          try {
            for (var _iterator13 = clickedItems[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
              var item = _step13.value;

              item.classList.remove('active');
            }
          } catch (err) {
            _didIteratorError13 = true;
            _iteratorError13 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion13 && _iterator13['return']) {
                _iterator13['return']();
              }
            } finally {
              if (_didIteratorError13) {
                throw _iteratorError13;
              }
            }
          }

          document.querySelector('.clicked-container').classList.remove('active');
        });
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12['return']) {
          _iterator12['return']();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }
  }

  function lightboxClick() {
    var ctas = document.querySelectorAll('.photos-cta');

    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      for (var _iterator14 = ctas[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        var cta = _step14.value;

        cta.addEventListener('click', function () {
          this.parentElement.querySelector('.lightbox-container').classList.add('active');
          document.querySelector('.clicked-container').classList.add('indexed');
        });
      }
    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14['return']) {
          _iterator14['return']();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }

    var closes = document.querySelectorAll('.lightbox-container .close-menu');

    var _iteratorNormalCompletion15 = true;
    var _didIteratorError15 = false;
    var _iteratorError15 = undefined;

    try {
      for (var _iterator15 = closes[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
        var close = _step15.value;

        close.addEventListener('click', function () {
          this.parentElement.parentElement.classList.remove('active');
          document.querySelector('.clicked-container').classList.remove('indexed');
        });
      }
    } catch (err) {
      _didIteratorError15 = true;
      _iteratorError15 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion15 && _iterator15['return']) {
          _iterator15['return']();
        }
      } finally {
        if (_didIteratorError15) {
          throw _iteratorError15;
        }
      }
    }
  }

  function initSliders() {
    new _swiper2['default']('.swiper-lightbox', {
      direction: 'horizontal',
      speed: 1000,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 50,
      threshold: 100,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination',
        dynamicBullets: true
      }
    });
  }

  (function init() {
    if (document.querySelector('.visual-container img')) {
      listHover();
      addListeners();
      chevronClick();
      listClick();
      lightboxClick();
      initSliders();
    }
  })();
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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